import BlockSpinner from "components/Spinners/BlockSpinner";
import { selectPropertyFromLocationHash } from "components/navigation/URL";
import { useSchemesQueryState } from "hooks/useScheme";
import type React from "react";
import { useLocation } from "react-router-dom";

// Blocks the routed content (wraps AdminRoutes, NOT the sidebar/navbar) only
// while resolving a scheme that is pinned in the URL hash whose (company-scoped)
// list is still loading — i.e. a deep-link / initial load. It deliberately does
// NOT block on a company switch (which clears the scheme from the hash) or a
// scheme switch (same list, not reloading). Because it sits below the navbar in
// Admin.tsx, the selectors stay mounted/usable even while it blocks.
// Asset-position groups load lazily via the components that consume them.
export default function SchemeListGate(props: {
  children: React.ReactNode;
}): React.ReactElement {
  const location = useLocation();
  const { loading } = useSchemesQueryState();
  const schemeInHash = Boolean(
    selectPropertyFromLocationHash("scheme", location.hash),
  );
  const blocking = schemeInHash && loading;

  return (
    <BlockSpinner loading={blocking}>
      {!blocking && <>{props.children}</>}
    </BlockSpinner>
  );
}
